import React, { useCallback, useEffect, useState } from "react";

import { getAllPartners } from "services";

import { copyToClipboard, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, Card, Col, MainPage, Row, Message as message } from "components";

export const PartnerList = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState({
    purchasedCredits: 0,
    purchaseObligations: 0,
    pendingCredits: 0,
    receivedCredits: 0,
    partners: 0,
  });
  const signal = useCancelAsyncOnUnmount()();

  const copyLink = (record) => {
    if (copyToClipboard(`${process.env.REACT_APP_FARM_URL}/sign-up?partner=${record.referralToken}`)) {
      message({
        content: "The gremlins successfully vomited the referral code into your clipboard.",
        icon: "gremlin",
      });
    } else {
      message({
        content: "The gremlins were confused and had an unexpected problem. Try again.",
        icon: "gremlin",
      });
    }
  };

  const copyDairyLink = (record) => {
    if (copyToClipboard(`${process.env.REACT_APP_FARM_URL}/sign-up/dairy?partner=${record.referralToken}`)) {
      message({
        content: "The gremlins successfully vomited the referral code into your clipboard.",
        icon: "gremlin",
      });
    } else {
      message({
        content: "The gremlins were confused and had an unexpected problem. Try again.",
        icon: "gremlin",
      });
    }
  };

  const loadPartners = useCallback(() => {
    getAllPartners({
      signal,
    })
      .then((res) => {
        setPartners(res.partners);
        setSummary(res.summary);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadPartners();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${partners.length} partners`}
        description="View, update or add partners here."
        extra={
          <Button size="small" type="secondary" href="/partners/add">
            Add
          </Button>
        }
      />

      <Row style={{ textAlign: "center" }}>
        <Col sm={24} md={6}>
          <Card className="content-card">
            <div style={{ margin: "0 auto" }}>
              <h3>{summary.purchasedCredits?.toFixed(3)}</h3>
              <p>Total purchased credits</p>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={6}>
          <Card className="content-card">
            <div style={{ margin: "0 auto" }}>
              <h3>{summary.purchaseObligations?.toFixed(3)}</h3>
              <p>Total purchase obligations</p>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={6}>
          <Card className="content-card">
            <div style={{ margin: "0 auto" }}>
              <h3>{summary.pendingCredits?.toFixed(3)}</h3>
              <p>Total pending credits</p>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={6}>
          <Card className="content-card">
            <div style={{ margin: "0 auto" }}>
              <h3>{summary.receivedCredits?.toFixed(3)}</h3>
              <p>Total received credits</p>
            </div>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <AdminTable
            dataSource={partners}
            config={{
              exclude: [
                "remainingCredits",
                "referralToken",
                "pointPriceCategory1",
                "pointPriceCategory2",
                "pointPriceCategory3",
                "pointPriceCategory4",
                "maxHectares",
                "contactPhone",
                "contactName",
                "contactEmail",
              ],
              actions: [
                {
                  icon: "tabler/arrow-right",
                  route: "/partners/update/",
                  tooltip: "Edit this partner",
                },
                {
                  icon: "tabler/copy",
                  func: copyLink,
                  tooltip: "Copy this CROPS referral link",
                },
                {
                  icon: "klim/cow",
                  func: copyDairyLink,
                  tooltip: "Copy this DAIRY referral link",
                },
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
